import { Grid } from '@mui/material';
import HtmlRender from 'components/Global/HtmlRender/HtmlRender';
import {
  LinkButton,
  LinkButtonType,
} from 'components/Global/LinkButton/LinkButton';
import { Picture } from 'components/Global/Picture/Picture';
import TextRender from 'components/Global/TextRender/TextRender';
import { INonReactModalData } from 'interfaces/modal';
import React from 'react';
import { useStyles } from './TextImageModalBase.styles';

interface ITextImageModalBase {
  modal: INonReactModalData;
  outOfReact?: boolean;
}

export default function TextImageModalBase({
  modal,
  outOfReact,
}: ITextImageModalBase): JSX.Element {
  const classes = useStyles();
  const dataLayer = window.Acr.dataLayer;
  var fullUrlRegex = new RegExp('^(?:[a-z+]+:)?//', 'i');
  return (
    <div className={classes.modal_data}>
      <h1 className={`acr-secondary-title-1 ${classes.modal_title}`}>
        <TextRender text={modal.headline} />
      </h1>
      <Grid container>
        <Grid item xs={12} md={6} className={classes.modal_image_area}>
          <Picture
            image={modal.image}
            classNames={{
              container: classes.modal_image_container,
              img: classes.modal_image,
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} className={classes.modal_text_area}>
          <div className={classes.text_description}>
            <div className={classes.modal_text}>
              <div className={`acr-paragraph-5`}>
                <HtmlRender text={modal.description} />
              </div>
              {modal.disclaimer && (
                <p className={`acr-paragraph-12 ${classes.disclaimer}`}>
                  <HtmlRender text={modal.disclaimer} />
                </p>
              )}
              {modal.ctas && modal.ctas.length !== 0 && (
                <LinkButton
                  variant={LinkButtonType.red}
                  classNames={{
                    link: classes.button_container,
                  }}
                  to={modal.ctas[0].url}
                  outOfReact={outOfReact}
                  isExternal={
                    fullUrlRegex.test(modal.ctas[0].url) && !outOfReact
                  }
                  target={fullUrlRegex.test(modal.ctas[0].url) ? '_blank' : ''}
                  trackEventData={{
                    modelSeries: dataLayer.Model.model_name,
                    modelYear: dataLayer.Model.model_year,
                    bodyStyle: dataLayer.Model.body_style,
                    modelTrim: dataLayer.Model.model_trim,
                    label: `${dataLayer.Model.model_name}:In Season:${modal.ctas[0].label}`,
                    category: { text:  `${dataLayer.Model.model_name} accessories`},
                    type: 'cta',
                  }}
                >
                  <TextRender text={modal.ctas[0].label} />
                </LinkButton>
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
